export default "__VITE_ASSET__CqSpNeSc__"